import { createContext } from 'react'

const defaultState = {
  userId: undefined,
  resident: undefined,
  user: { attributes: {} },
  accessToken: undefined,
  admin: undefined,
  setAdmin: function(_val) {},
  nonResident: undefined,
  setNonResident:function(_val) {},
  resetContext: function() {},
  setShowFacebook: function(_val) {},
}

export const ImperialBookingContext = createContext(defaultState)
